import * as TooltipRadix from "@radix-ui/react-tooltip";
import * as React from "react";
import { ReactNode } from "react";
import { cn } from "lib/cn";

const tooltipContent = cn(
    "z-20 rounded-md bg-white p-3 text-xs text-slate-500 shadow-md select-none animate-show opacity-100 transform transition-transform duration-400 ease-out",
);
const tooltipArrow = cn("fill-white");

type TooltipProps = {
    children: ReactNode | string;
    content: ReactNode | string;
    disabled?: boolean;
};

export const Tooltip = ({ children, content, disabled }: TooltipProps) => {
    if (disabled) {
        return <span>{children}</span>;
    }

    return (
        <TooltipRadix.Provider delayDuration={100}>
            <TooltipRadix.Root>
                <TooltipRadix.Trigger asChild>{children}</TooltipRadix.Trigger>
                <TooltipRadix.Portal>
                    <TooltipRadix.Content className={tooltipContent} sideOffset={5}>
                        {content}
                        <TooltipRadix.Arrow className={tooltipArrow} />
                    </TooltipRadix.Content>
                </TooltipRadix.Portal>
            </TooltipRadix.Root>
        </TooltipRadix.Provider>
    );
};
